import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ExtensionReportSortBy } from '@ndt/report-output/shared/models/extension-sort-by-report-parameter';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { ReportParameterComponent } from '../../report-parameter-list/report-parameter-component';
import { ReportParameterConfig } from '../../report-parameter-list/report-parameter.config';

@Component({
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: ExtensionSortByReportParameterComponent }],
    selector: 'ndt-extension-sort-by-report-parameter',
    templateUrl: './extension-sort-by-report-parameter.component.html',
    standalone: false
})
export class ExtensionSortByReportParameterComponent implements OnDestroy, AfterViewInit, ReportParameterComponent {
   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   config: ReportParameterConfig;

   extensionSortBy = Object.values(ExtensionReportSortBy);

   constructor() {
      this.form = new UntypedFormGroup({
         value: new UntypedFormControl(ExtensionReportSortBy.Number),
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   ngAfterViewInit(): void {
      this.form.controls.isAskParameter?.valueChanges.pipe(delay(0), takeUntil(this.destroyed$)).subscribe(() => {
         this.form.controls.ExtensionSortBy?.updateValueAndValidity();
      });
   }

   extensionSortByDisplayWith(option: ExtensionReportSortBy): string {
      return `${option ?? ''}`;
   }
}
